import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import API from "../api/axios";
import ProductList from "../components/ProductList";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SearchResults = () => {
  const queryParam = useQuery().get("query") || "";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchSearchResults = async () => {
      setLoading(true);
      setError("");
      try {
        const { data } = await API.get(`/products/search?query=${encodeURIComponent(queryParam)}`);
        setProducts(data);
      } catch (err) {
        console.error("Error en la búsqueda:", err);
        setError("Error al buscar productos");
      } finally {
        setLoading(false);
      }
    };
    if (queryParam) {
      fetchSearchResults();
    }
  }, [queryParam]);

  return (
    <div className="container mx-auto mt-10 px-4">
      <h2 className="text-2xl font-bold text-center mb-4">Resultados de búsqueda para "{queryParam}"</h2>
      {loading && <p className="text-center">Cargando...</p>}
      {error && <p className="text-center text-red-500">{error}</p>}
      {!loading && products.length === 0 && <p className="text-center">No se encontraron productos.</p>}
      {products.length > 0 && <ProductList products={products} />}
    </div>
  );
};

export default SearchResults;
